import React, { useEffect, useState, useRef } from "react";
import { Text } from "@chakra-ui/react";

interface TypewriterTextProps {
  text: string;
  delay?: number;
  onComplete?: () => void;
}

export const TypewriterText = ({
  text,
  delay = 0,
  onComplete,
}: TypewriterTextProps) => {
  const [displayText, setDisplayText] = useState("");
  const isCompletedRef = useRef(false);

  useEffect(() => {
    if (isCompletedRef.current) return;

    let currentIndex = 0;
    const typingSpeed = 50; // Use consistent speed
    let timeoutId: NodeJS.Timeout;

    const typeNextChar = () => {
      if (currentIndex <= text.length) {
        setDisplayText(text.slice(0, currentIndex));
        currentIndex++;
        timeoutId = setTimeout(typeNextChar, typingSpeed);
      } else {
        isCompletedRef.current = true;
        onComplete?.();
      }
    };

    // Initial delay before starting
    const startTimeout = setTimeout(typeNextChar, delay * 1000);

    return () => {
      clearTimeout(startTimeout);
      clearTimeout(timeoutId);
    };
  }, [text, delay]); // Intentionally leave onComplete out of dependencies to prevent re-rendering

  return (
    <Text fontSize="md" color="gray.600" as="span">
      {displayText}
    </Text>
  );
};
